module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-tab",
    attrs: {
      "id": "foot"
    }
  }, [_c('div', {
    staticClass: "weui-tab__panel"
  }), _vm._v(" "), _c('div', {
    staticClass: "weui-tabbar"
  }, [_c('a', {
    staticClass: "weui-tabbar__item",
    attrs: {
      "href": "#/index/home/list/pop/1"
    },
    on: {
      "click": function($event) {
        _vm.showfoot(1)
      }
    }
  }, [_c('span', {
    staticClass: "weui-tabbar__icon img1",
    class: {
      img11: _vm.isshowfoot == 1
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "weui-tabbar__label"
  }, [_vm._v("主页")])]), _vm._v(" "), _c('a', {
    staticClass: "weui-tabbar__item",
    attrs: {
      "href": "#/index/category"
    },
    on: {
      "click": function($event) {
        _vm.showfoot(2)
      }
    }
  }, [_c('span', {
    staticClass: "weui-tabbar__icon img2",
    class: {
      img21: _vm.isshowfoot == 2
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "weui-tabbar__label"
  }, [_vm._v("分类")])]), _vm._v(" "), _c('a', {
    staticClass: "weui-tabbar__item",
    attrs: {
      "href": "#/car"
    },
    on: {
      "click": function($event) {
        _vm.showfoot(3)
      }
    }
  }, [_c('span', {
    staticClass: "weui-tabbar__icon img3",
    class: {
      img31: _vm.isshowfoot == 3
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "weui-tabbar__label"
  }, [_vm._v("购物车")])]), _vm._v(" "), _c('a', {
    staticClass: "weui-tabbar__item",
    attrs: {
      "href": "#/mycenter"
    },
    on: {
      "click": function($event) {
        _vm.showfoot(4)
      }
    }
  }, [_c('span', {
    staticClass: "weui-tabbar__icon img4",
    class: {
      img41: _vm.isshowfoot == 4
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "weui-tabbar__label"
  }, [_vm._v("我")])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-f60a2d70", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-f60a2d70","hasScoped":true}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./app/component/xfooter.vue
// module id = 89
// module chunks = 0